import axios from 'axios';

class FootballService {

    getNextMatches() {
        return axios.get(`http://localhost:3001/football`);
    }
}

export default (new FootballService()); // singleton object